var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenCircleTick = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM8.3575 11.5996L13.8575 5.97456L13.1425 5.27544L7.99865 10.5362L5.98118 8.48838L5.26882 9.19019L7.64382 11.6009L8.00135 11.9638L8.3575 11.5996Z",
    fill: "#1DC7B2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenCircleTick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/green-circle-tick.bee5f87611fe32fa9477c09471d9731f.svg";